module.exports = __webpack_public_path__ + "img/ico052.017907fc.svg";